/* eslint-disable no-unused-vars */
import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';

// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { OrderListHead, OrderListToolbar, OrderModal, OrderUpdate } from '../sections/@dashboard/order';
// api
import API from '../api';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'index', label: '№', alignRight: false },
  { id: 'orderNumber', label: 'Захиалгын дугаар', alignRight: false },
  { id: 'address', label: 'Хаяг', alignRight: false },
  { id: 'date', label: 'Огноо', alignRight: false },
  { id: 'amount', label: 'Дүн', alignRight: false },
  { id: 'phoneNum', label: 'Захиалагч', alignRight: false },
  { id: 'status', label: 'Төлөв', alignRight: false },
  // { id: 'description', label: 'Дэд гарчиг', alignRight: false },
  // // { id: 'createdAt', label: 'Бүртгэсэн огноо', alignRight: false },
  // { id: 'posted_date', label: 'Нийтлэсэн огноо', alignRight: false },
  // { id: 'status', label: 'Төлөв', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

export default function OrderPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [loading, setLoading] = useState(false);

  // const [selectedCategory, setSelectedCategory] = useState({});

  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [news, setNews] = useState([]);

  const [selectedNews, setSelectedNews] = useState({});

  const [totalNewsCount, setTotalNewsCount] = useState(0);

  const [catID, setCatID] = useState(null);
  const [subCatID, setSubCatID] = useState(null);

  const [payload, setPayload] = useState(null);

  const fetchNews = async ({ page = 1, limit = 20, payload }) => {
    const accessToken = localStorage.getItem('token'); // Trim the token
    console.log(accessToken);
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    const response = await API.get(`/order?page=${page}&limit=${limit}`, config);
    const {
      data: {
        data,
        pagination: { total },
      },
    } = response;
    setNews(data);
    setTotalNewsCount(total);
    console.log(data);
  };
  const formatToMNT = (amount) => {
    return new Intl.NumberFormat('mn-MN', {
      style: 'currency',
      currency: 'MNT',
    }).format(amount);
  };
  const filterSearch = async (payload) => {
    setPayload(payload);
    const {
      title,
      newsId,
      selectedUser,
      startDate,
      endDate,
      selectedCategory,
      selectedSubCategory,
      page = 1,
      limit = rowsPerPage,
    } = payload;
    const formattedStartDate = dayjs(new Date(startDate)).format('YYYY-MM-DD');
    const formattedEndDate = dayjs(new Date(endDate)).format('YYYY-MM-DD');

    const response = await API.get(`/product?page=${page}&limit=${limit}`, {});
    const {
      data: {
        data,
        success,
        pagination: { total },
      },
    } = response;
    if (success === 1) {
      setNews(data);
      setTotalNewsCount(total);
    }
  };

  const [categories, setCategories] = useState([]);

  const fetchCategories = async () => {
    const response = await API.get('/categories');
    const {
      data: { data, success },
    } = response;

    if (success) setCategories(data);
  };

  const resetPage = () => {
    setPage(0);
    setPayload(null);
    setSelectedNews({});
    setOpen(false);
    try {
      setLoading(true);
      fetchNews({ page, limit: rowsPerPage });
      fetchCategories();
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try {
      setLoading(true);
      if (payload) {
        filterSearch({ ...payload, page: page + 1, limit: rowsPerPage });
      } else {
        fetchNews({ payload, page: page + 1, limit: rowsPerPage });
      }
      fetchCategories();
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const handleStatus = async () => {
    // todo: call api
    try {
      const response = await API.get(`/order/status/${selectedNews._id}`);
      const {
        data: { success },
      } = response;

      if (success) {
        handleCloseMenu();
        fetchNews(page, rowsPerPage);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleOpenMenu = (event, selectedNews) => {
    setOpen(event.currentTarget);
    setSelectedNews(selectedNews);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const onSelectCategory = (category) => {
    setPage(0);
    // setSelectedCategory(category);
  };

  return (
    <>
      <Helmet>
        <title> Захиалга </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Захиалга
          </Typography>

          {/* <OrderModal resetPage={resetPage} categories={categories} /> */}
        </Stack>

        <Card>
          {/* <NewsListToolbar
            resetPage={resetPage}
            onSelectCategory={onSelectCategory}
            categories={categories}
            filterSearch={filterSearch}
          /> */}
          {loading ? (
            <CircularProgress />
          ) : (
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <OrderListHead headLabel={TABLE_HEAD} rowCount={news.length} />
                  <TableBody>
                    {news.length > 0 ? (
                      news.map((row, index) => {
                        const { _id, orderNumber, invoiceCode, deliveryAddress, amount, createdAt, userId, status } =
                          row;

                        return (
                          <TableRow
                            hover
                            key={_id}
                            sx={{
                              position: 'relative',
                            }}
                          >
                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap px={2}>
                                  {index + 1}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography
                                  variant="subtitle2"
                                  style={{
                                    wordWrap: 'break-word',
                                  }}
                                  px={2}
                                >
                                  {orderNumber}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography
                                  variant="subtitle2"
                                  style={{
                                    wordWrap: 'break-word',
                                  }}
                                  maxWidth={300}
                                  px={2}
                                >
                                  {deliveryAddress}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" px={2}>
                                  {format(new Date(createdAt), 'yyyy-MM-dd')}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {formatToMNT(amount)}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {userId.phoneNum}
                                </Typography>
                              </Stack>
                            </TableCell>{' '}
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {status}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={(event) => handleOpenMenu(event, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Өгөгдөл олдсонгүй
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}

          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={totalNewsCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <OrderUpdate selectedOrder={selectedNews} resetPage={resetPage} categories={categories} />
        </MenuItem>

        <MenuItem onClick={handleStatus} sx={{ color: 'blue' }}>
          <CheckIcon sx={{ marginRight: '2px' }} />
          Хүргэгдсэн
        </MenuItem>
      </Popover>
    </>
  );
}
